module.exports = __webpack_public_path__ + "assets/media/lunch.d53f15b6.mp3";